// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__25OUs","consentsList":"PatientConsents_consentsList__373XW","consentsListEmpty":"PatientConsents_consentsListEmpty__rLpi-"};